/**
 * Wrapper HTTP read-only para o dashboard (F11b §9.5, ADR-F11-008).
 *
 * Dashboard NÃO chama confirm/cancel/edit (ADR-F11-008). Apenas lista
 * approvals do user logado (manager+admin enxergam só os próprios pelo
 * filtro user_id do JWT no backend F11a).
 */

import type { components } from '@copilot/shared-types';
import { httpClient } from '../../shared/http/client';

export type HitlApproval = components['schemas']['HitlApprovalRead'];
export type ApprovalStatus = HitlApproval['status'];
export type HitlApprovalListResponse = components['schemas']['HitlApprovalListResponse'];

export interface ListApprovalsParams {
  status?: ApprovalStatus;
  toolName?: string;
  page?: number;
  perPage?: number;
}

export async function listApprovals(
  params: ListApprovalsParams = {},
): Promise<HitlApprovalListResponse> {
  const query: Record<string, string | number> = {};
  if (params.status !== undefined) query.status = params.status;
  if (params.page !== undefined) query.page = params.page;
  if (params.perPage !== undefined) query.per_page = params.perPage;
  const res = await httpClient.get<HitlApprovalListResponse>('/api/v1/approvals', {
    params: query,
  });
  // Filtro tool_name client-side (backend não expõe esse filtro v1).
  if (params.toolName !== undefined && params.toolName.length > 0) {
    const term = params.toolName.toLowerCase();
    return {
      ...res.data,
      data: res.data.data.filter((a) => a.tool_name.toLowerCase().includes(term)),
    };
  }
  return res.data;
}
